import React, { useState } from "react";
import API from "../api/axios";
import { useNavigate } from "react-router-dom";
import { Mail, Lock, LogIn, AlertCircle, Loader2 } from "lucide-react";
import logo from '../asset/kestren.png';

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await API.post("/auth/login", form);
      localStorage.setItem("token", res.data.token);
      navigate("/dashboard");
    } catch (err) {
      const backendMsg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Invalid email or password";
      setError(backendMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Main Login Card with Logo Inside */}
        <div className="bg-white rounded-3xl shadow-2xl border border-gray-200 p-10">

          {/* Logo + Title Inside Card */}
          <div className="text-center mb-10">
            <div className="flex justify-center mb-6">
              <img
                src={logo}
                alt="Wallet App Logo"
                className="w-28 h-28 rounded-3xl shadow-xl border-4 border-gray-200"
              />
            </div>
            <h1 className="text-4xl font-bold text-gray-800">
              Client Login
            </h1>
            <p className="text-gray-600 mt-3 text-lg">
              Welcome back! Sign in to your wallet
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email */}
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 text-gray-500" />
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="Enter your email"
                className="w-full pl-14 pr-5 py-4 bg-gray-50 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-gray-600 transition-all text-gray-800 font-medium"
                required
              />
            </div>

            {/* Password */}
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 text-gray-500" />
              <input
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="Enter your password"
                className="w-full pl-14 pr-5 py-4 bg-gray-50 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-gray-600 transition-all text-gray-800 font-medium"
                required
              />
            </div>

            {/* Error */}
            {error && (
              <div className="flex items-center gap-3 p-5 bg-red-50 border border-red-200 text-red-700 rounded-2xl">
                <AlertCircle className="w-6 h-6 flex-shrink-0" />
                <p className="font-medium">{error}</p>
              </div>
            )}

            {/* Login Button */}
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-5 rounded-2xl font-bold text-white flex items-center justify-center gap-3 transition-all duration-300 shadow-lg
                ${loading ? "bg-gray-500 cursor-not-allowed" : "bg-gray-800 hover:bg-gray-900 hover:shadow-xl"}
              `}
            >
              {loading ? (
                <>
                  <Loader2 className="w-6 h-6 animate-spin" />
                  Signing in...
                </>
              ) : (
                <>
                  <LogIn className="w-6 h-6" />
                  Login to Dashboard
                </>
              )}
            </button>
            {/* Forgot Password */}
            <div className="text-end">
              <p
                onClick={()=>navigate('/forget-password')}
                className="text-gray-700 font-medium hover:underline cursor-pointer"
              >
                Forgot Password ?
              </p>
            </div>

          </form>

          {/* Register Link */}
          <div className="mt-8 text-center">
            <p className="text-gray-600 text-base">
              New here?{" "}
              <a
                href="/register"
                className="font-bold text-gray-800 hover:underline"
              >
                Create an account
              </a>
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-gray-500 mt-10 font-medium">
          © {new Date().getFullYear()} KESTREN • Powered by  KESTREN
        </p>

      </div>
    </div>
  );
}